import { z } from 'zod';
import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';

export const querySchema = z
  .object({
    search: z.string().default(''),
    valid_license_on: z.string().optional(),
    license_year: z.coerce.number().optional(),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
